import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAccountConsents } from "../../api/consentsApi";
import { formatDateTime } from "../../components/midpoint/admin/users/adminUserFormatters";
import { publicPathForDocumentType } from "../../utils/legalRoutes";

const AccountConsentsPage = () => {
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setIsLoading(true);
        const body = await getAccountConsents();
        if (!cancelled) {
          setData(body);
        }
      } catch (error) {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load consent history.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="panel-card">
      <h2>Legal &amp; consent</h2>
      <p className="muted">
        View documents you have accepted. Historical records are kept for compliance. Optional
        email notification consent can be managed on{" "}
        <Link to="/account/notifications">Notifications</Link>.
      </p>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
      {isLoading ? <p className="muted">Loading…</p> : null}

      {data?.missingRequiredConsents?.length ? (
        <p className="admin-data-health-error">
          Action needed: accept current versions on{" "}
          <Link to="/account/consent-required">Consent required</Link>.
        </p>
      ) : null}

      {data?.acceptedDocuments?.length ? (
        <table className="admin-data-health-table">
          <thead>
            <tr>
              <th>Document</th>
              <th>Version</th>
              <th>Accepted</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {data.acceptedDocuments.map((entry) => (
              <tr key={`${entry.documentType}-${entry.version}`}>
                <td>
                  <Link to={publicPathForDocumentType(entry.documentType)}>{entry.title}</Link>
                </td>
                <td>{entry.version}</td>
                <td>{formatDateTime(entry.acceptedAt)}</td>
                <td>{entry.source || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}

      {!isLoading && !data?.acceptedDocuments?.length ? (
        <p className="muted">No accepted documents recorded yet.</p>
      ) : null}
    </section>
  );
};

export default AccountConsentsPage;
